export const requireEmailTitle = 'Поле "Email" обязательно к заполнению';
export const requirePasswordTitle = 'Поле "Пароль" обязательно к заполнению';